module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-payment-data"
  }, [_c('div', {
    staticClass: "order-payment-col"
  }, [_c('img', {
    attrs: {
      "src": _vm.logoBank,
      "alt": "",
      "height": "41"
    }
  }), _vm._v(" "), (_vm.success) ? _c('p', {
    staticClass: "title"
  }, [_vm._v("¡Gracias por comprar en MI STORE!")]) : _c('p', {
    staticClass: "title"
  }, [_vm._v("El pedido ha sido cancelado.")]), _vm._v(" "), (_vm.description) ? _c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.description))]) : (_vm.gatewayTransactionId) ? _c('p', {
    staticClass: "transaction-data",
    style: (("color:" + (_vm.globalColors.primary)))
  }, [_vm._v("\n\t\t\tNro de Transacción: " + _vm._s(_vm.gatewayTransactionId) + "\n\t\t")]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('p', [_vm._v("Te enviaremos un correo electrónico cuando esté en camino.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "order-payment-col"
  }, [(!_vm.cardNumber) ? _c('div', {
    staticClass: "container-data"
  }, [_c('p', {
    staticClass: "account-data title",
    style: (("color:" + (_vm.globalColors.primary)))
  }, [_vm._v("Cuenta Bancaria Mi Store:")]), _vm._v(" "), _c('p', {
    staticClass: "account-data"
  }, [_vm._v("Nombre de Cuenta: " + _vm._s(_vm.accountName))]), _vm._v(" "), _c('p', {
    staticClass: "account-data"
  }, [_vm._v("Nro. de Cuenta: " + _vm._s(_vm.accountNumber))])]) : _c('div', {
    staticClass: "container-data"
  }, [_c('p', {
    staticClass: "account-data title",
    style: (("color:" + (_vm.globalColors.primary)))
  }, [_vm._v("Datos de Transacción:")]), _vm._v(" "), _c('p', {
    staticClass: "account-data"
  }, [_vm._v("Nro. Tarjeta: " + _vm._s(_vm.cardNumber))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-486129b0","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/order-payment-data.vue
// module id = 1108
// module chunks = 2